<template>
    <div class="form">
        <Form ref="info"
            :model="info"
            :rules="ruleValidate"
            :label-width="100">
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="活动名称"
                    prop="actName">
                    <Input v-model="info.actName"
                        placeholder
                        :maxlength="50"
                        :readonly="readonly"></Input>
                </FormItem>
                <FormItem label="活动项目"
                    prop="projId">
                    <Select v-model="info.projId"
                        transfer
                        placeholder
                        :readonly="readonly"
                        @on-change="clearRids">
                        <Option v-for="(item, index) in projList"
                            :value="item.id"
                            :key="index">{{item.projName}}</Option>
                    </Select>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="活动图片"
                    prop="attachments">
                    <preview-upload :readonly="readonly"
                        v-model="info.attachments"
                        :format="imgSuffix"></preview-upload>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="开始时间"
                    prop="startTime">
                    <date-picker :readonly="readonly"
                        style="width: 100%"
                        v-model="info.startTime"
                        transfer
                        type="datetime"></date-picker>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="结束时间"
                    prop="endTime">
                    <date-picker :readonly="readonly"
                        style="width: 100%"
                        v-model="info.endTime"
                        transfer
                        type="datetime"></date-picker>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="活动类型"
                    prop="actType">
                    <Input :value="dict.actType.val(info.actType)"
                        placeholder
                        disabled></Input>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="重复选房"
                    prop="repeatSelect">
                    <i-switch :readonly="readonly"
                        v-model="info.repeatSelect"
                        size="large"
                        :true-value="1"
                        :false-value="0">
                        <span slot="open">是</span>
                        <span slot="close">否</span>
                    </i-switch>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="秒杀均价"
                    prop="spikeAveragePrice">
                    <input-number v-model="info.spikeAveragePrice"
                        placeholder
                        :readonly="readonly">
                        <span slot="append">万元/套</span>
                    </input-number>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="认购金额"
                    prop="buyAmount">
                    <input-number v-model="info.buyAmount"
                        placeholder
                        :readonly="readonly">
                        <span slot="append">元</span>
                    </input-number>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                <FormItem label="活动房源"
                    prop="rids">
                    <form-lookup placeholder="请选择活动房源"
                        title="选择活动房源"
                        v-model="info.rids"
                        textSymbol="title"
                        valueSymbol="id"
                        :modalHeight="480"
                        :modalWidth="480"
                        :readonly="!info.projId || readonly"
                        :options.sync="resourcesOptions">
                        <select-house :projId="info.projId"></select-house>
                    </form-lookup>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                <FormItem label="活动说明"
                    prop="remark">
                    <Input :readonly="readonly"
                        type="textarea"
                        :rows="3"
                        v-model="info.remark"
                        :maxlength="1000"
                        placeholder></Input>
                </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import { actAdd, actUpdate, actView } from '@/api/act-info'
import { fileAdd, fileUpdate } from '@/api/sys-oss'
import dayjs from 'dayjs'
import { projList } from '@/api/proj-manager'
import Dict from '@/utils/dict'
import PreviewUpload from '_c/preview-upload'
import SelectHouse from '_v/components/select-house'
export default {
    name: 'ActForm',
    props: {
        id: {
            type: [String, Number],
            default: ''
        }
    },

    components: { PreviewUpload, SelectHouse },

    inject: {
        $modal: {
            default: null
        }
    },

    data() {
        return {
            imgSuffix: this.$config.upload.imgSuffix,
            loading: false,
            info: {
                id: this.id,
                actName: '', // 项目名称
                projId: '', //活动项目
                attachments: '', //活动图片
                startTime: '', //开始时间
                endTime: '', //结束时间
                actType: '1', //活动类型
                actStatus: '', //状态
                repeatSelect: 1, //重复选房
                spikeAveragePrice: '', //秒杀均价
                buyAmount: '', //认购金额
                rids: '', //活动房源
                remark: '', // 其他
                ver: '' // 版本号
            },
            projList: [],
            resourcesOptions: [],
            dict: {
                actType: Dict.NULL
            }
        }
    },

    computed: {
        canSave() {
            return this.id ? this.$can("update") : this.$can("add")
        },

        readonly() {
            return this.loading || (!!this.id && this.info.actStatus != 0) || !this.canSave
        },

        ruleValidate() {
            return {
                actName: [{ required: true, message: '项目名称必填' }],
                projId: [{ required: true, message: '活动项目必填' }],
                // attachments: [{ required: true, message: '活动图片必填' }],
                startTime: [{ required: true, message: '开始时间必填' }],
                endTime: [{ required: true, message: '结束时间必填' }],
                spikeAveragePrice: [
                    { required: true, message: '秒杀均价必填' }
                ],
                buyAmount: [{ required: true, message: '认购金额必填' }],
                rids: [{ required: true, message: '活动房源必填' }]
            }
        },
    },

    methods: {
        fetch() {
            if (this.id) {
                return actView(this.id)
            } else {
                return Promise.resolve()
            }
        },
        clearRids() {
            this.info.rids = ""
            this.resourcesOptions = []
        }
    },

    mounted() {
        var $info = this.$refs.info,
            btns = [{ type: "default", text: "关闭", name: "cancel" }]

        this.loading = true

        // 按钮定制
        if (this.canSave) {
            btns.unshift({ type: "primary", text: "保存", name: "confirm" })
        }
        this.$modal.updateBtns(btns)

        // 预加载
        this.$modal.beforeEnter(next => {
            let body = {
                page: 1,
                pageSize: 999
            }

            Promise.all([Dict.get(['act_type']), projList(body), this.fetch()])
                .then(args => {
                    var [dictGroup, proj, view] = args
                    Object.keys(this.dict).forEach(name => {
                        this.dict[name] = dictGroup[name] || Dict.NULL
                    })
                    this.projList = proj.data.page.list
                    if (view) {
                        var viewData = view.data
                        viewData.startTime = dayjs(viewData.startTime).format(
                            'YYYY-MM-DD HH:mm:ss'
                        )
                        viewData.endTime = dayjs(viewData.endTime).format(
                            'YYYY-MM-DD HH:mm:ss'
                        )
                        // null会显示异常
                        viewData.attachments = viewData.attachments ?
                            viewData.chments :
                            ''
                        let resourcesOptions = viewData.resourcesOptions || []
                        this.resourcesOptions = resourcesOptions.map(el => {
                            return {
                                id: el.id,
                                title: el.houseName
                            }
                        })
                        Object.keys(this.info).forEach(
                            name => (this.info[name] = viewData[name])
                        )
                    }
                    if (this.id && this.info.actStatus != 0) {
                        // 已发布的活动不能修改
                        this.$modal.updateBtns('confirm', {
                            disabled: true
                        })
                    } else {
                        this.$modal.updateBtns('confirm', {
                            disabled: false
                        })
                    }
                })
                .finally(() => {
                    this.loading = false
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    this.loading = true
                    var formData = Object.assign({}, this.info)
                    formData.startTime = dayjs(formData.startTime).format(
                        'YYYY-MM-DD HH:mm:ss'
                    )
                    formData.endTime = dayjs(formData.endTime).format(
                        'YYYY-MM-DD HH:mm:ss'
                    )
                    this.loading = true
                    if (this.id) {
                        return actUpdate(formData)
                    } else {
                        return actAdd(formData)
                    }
                })
                .then(res => {
                    if (this.id) {
                        this.$Message.success(this.$t('tips.update.success'))
                    } else {
                        this.$Message.success(this.$t('tips.add.success'))
                    }
                })
                .catch(err => {
                    options.closeModal = false
                })
                .finally(() => {
                    this.loading = false
                    next()
                })
        })
    }
}
</script>
<style lang="less"
    scoped>
</style>